export const serviceTypeOptions = [
  { value: "ALL", label: "All" },
  { value: "A2C", label: "Airport To City" },
  { value: "C2A", label: "City To Airport" },
  { value: "C2C", label: "City To City" },
];

export const serviceTypeMap = {
  A2C: "AirportToCity",
  C2A: "CityToAirport",
  C2C: "CityToCity",
  ALL: "All",
};

export const reverseServiceTypeMap = {
  AirportToCity: "A2C",
  CityToAirport: "C2A",
  CityToCity: "C2C",
  All: "ALL",
};

export const RIDE_TYPE_OPTIONS = [
  { value: 'All', label: 'All' },
  { value: 'CityToAirport', label: 'City To Airport' },
  { value: 'AirportToCity', label: 'Airport To City' },
  { value: 'CityToCity', label: 'City To City' },
];

export const getRideTypeLabel = (value) =>
  RIDE_TYPE_OPTIONS.find((o) => o.value === value)?.label || value || '-';
